import script from "./Study.vue?vue&type=script&setup=true&lang=js"
export * from "./Study.vue?vue&type=script&setup=true&lang=js"

import "./Study.vue?vue&type=style&index=0&id=87fb56dc&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87fb56dc"]])

export default __exports__